<template>
  <section>
    <h1>ℹ️ Über uns</h1>
    <p>Diese Seite wird bei <code>/about</code> angezeigt.</p>
  </section>
</template>
